//TODO : Refactor after ai
import type { HTMLAttributes } from "react";
import type { ToneColor } from "./types";
import { Badge } from "./primitives";

export interface ObjectTypeBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  type?: string;
  identifier?: string;
  color?: ToneColor;
  size?: "sm" | "md" | "lg";
}

/** Object-class label plus the record's human identifier. */
export function ObjectTypeBadge({
  type,
  identifier,
  color = "brand",
  size = "sm",
  className = "",
  ...rest
}: ObjectTypeBadgeProps) {
  return (
    <span className={`bui-obj-eyebrow ${className}`} {...rest}>
      {type && (
        <Badge color={color} variant="light" size={size} radius="rounded">
          {type}
        </Badge>
      )}
      {identifier && <span className="bui-obj-id">{identifier}</span>}
    </span>
  );
}
